export default __webpack_public_path__ + "static/media/FLAngry.e64e1126.svg";